export const MOBILE_BREAKPOINT = 832;
export const ATTACHMENTS_PANEL_OVERLAY_BREAKPOINT = 1250;